import React from "react";
import TopBar from "../components/layout/TopBar";
import ForecastPanel from "../components/growth/ForecastPanel";
import Milestones from "../components/growth/Milestones";
import ConfidenceBadge from "../components/growth/ConfidenceBadge";
import useApi from "../hooks/useApi";
import { useBranch } from "../context/BranchContext";

export default function GrowthForecast() {
  const { branchId } = useBranch();
  const { data } = useApi(`/growth/forecast?branch_id=${branchId}`, [branchId]);

  const hero = (
    <div className="mb-6 animate-rise">
      <h1 className="text-3xl font-extrabold tracking-tighter text-ink">Growth Forecast</h1>
      <p className="text-ink-2 mt-1">Exactly how your branch could improve its Growth Score — and what it would take.</p>
    </div>
  );

  if (!data) return <><TopBar /><div className="p-6 sm:p-8 max-w-[1200px]">{hero}<div className="h-64 rounded-xl animate-pulse" style={{ background: "#EDEEE9" }} /></div></>;

  return (
    <>
      <TopBar />
      <div className="p-6 sm:p-8 max-w-[1200px]">
        {hero}
        <ForecastPanel forecast={data} full />
        <div className="mt-6"><Milestones milestones={data.milestones} /></div>
        <div className="mt-6 card p-6" data-testid="forecast-confidence-legend">
          <span className="label-caps">Forecast confidence</span>
          <p className="text-sm text-ink-2 mt-2 leading-relaxed">
            Completing these actions could increase your Growth Score by approximately <span className="font-bold text-ink">+{data.gain} points</span>.
            Each opportunity is graded by the quality of the underlying data — we forecast score potential, not revenue or instructions.
          </p>
          <div className="flex items-center gap-2 mt-3 flex-wrap">
            <ConfidenceBadge level="HIGH" />
            <ConfidenceBadge level="MEDIUM" />
            <ConfidenceBadge level="ESTIMATED" />
          </div>
        </div>
      </div>
    </>
  );
}
